import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
} from '@mui/material';

import { Option } from 'types/Form';

export type SelectRowProps = SelectProps & {
  options?: Array<Option | string>;
  helperText?: string;
  alert?: boolean;
  multiple?: boolean;
};

export const SelectRow = (props: SelectRowProps) => {
  const {
    title,
    disabled,
    required,
    options,
    children,
    sx,
    id,
    helperText,
    alert,
    ...rest
  } = props;

  return (
    <FormControl fullWidth sx={sx}>
      {title && (
        <InputLabel id={id} required={required} disabled={disabled}>
          {title}
        </InputLabel>
      )}
      <Select label={title} labelId={id} disabled={disabled} {...rest}>
        {options
          ? options.map((option) =>
              typeof option === 'string' ? (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ) : (
                <MenuItem
                  key={`${option.label}-${option.value}`}
                  value={option.value}
                >
                  {option.label}
                </MenuItem>
              ),
            )
          : children}
      </Select>
      {helperText && (
        <FormHelperText error={alert}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};
